import SearchIcon from "@mui/icons-material/Search";
import { Box, Button, Chip, InputAdornment, Modal, TextField, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReusableTable from "../../common/table/CommonTable";
import { deleteDoctor, fetchDoctors } from "../../redux/doctor/doctorAction";

const ListDoctor = () => {
  const [loading, setLoading] = useState(false);
  const [openDeleteModel, setopenDeleteModel] = useState(false);
  const [deleteId, setdeleteId] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  
  const DoctorState = useSelector(
    (state) => state?.doctor?.fetchListDoctors || {}
  );
  const deleteDoctorState = useSelector((state) => state.doctor.deleteDoctor || {});
  const totalPages = deleteDoctorState?.doctor?.totalPages || 0;

  const fetchData = async (page) => {
    setLoading(true);
    await dispatch(fetchDoctors(page));
    setLoading(false);
  };
  
  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, dispatch]);
  
  useEffect(() => {
    if(deleteDoctorState.success){
      dispatch(fetchDoctors());
    }
  },[deleteDoctorState]);

  const rawData = DoctorState?.data?.data || [];

  const data = useMemo(() => {
    return Array.isArray(rawData)
      ? rawData.map((doc) => ({
          ids: doc.id || "N/A",
          id: doc.doctor_id || "N/A",
          name: doc.doctor_name || "N/A",
          email: doc.email || "N/A",
          phone: doc.phone || "N/A",
          status: doc.User?.status === 1 ? "Active" : "Inactive",
        }))
      : [];
  }, [rawData]);
      
  // Filter data based on search term using useMemo to prevent infinite loops
  const filteredData = useMemo(() => {
    if (searchTerm.trim() === "") {
      return data;
    } else {
      return data.filter((item) =>
        Object.values(item).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
  }, [data, searchTerm]);

  const columns = [
    {
      id: "id",
      label: "User ID",
      sortable: true,
      render: (value, row) => (
        <Typography
          component="span"
          sx={{
            cursor: "pointer",
            color: "dodgerblue",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
          onClick={() => handleViewClick(row)}
        >
          {value}
        </Typography>
      ),
    },
    // { id: "id", label: "User ID", sortable: true },
    { id: "name", label: "Name", sortable: true },
    { id: "email", label: "Email", sortable: true },
    { id: "phone", label: "Phone Number", sortable: true },
    {
      id: "status",
      label: "Status",
      sortable: true,
      render: (value) => (
        <Chip
          label={value}
          color={value === "Active" ? "success" : "warning"}
        />
      ),
    },
  ];
  
  const handleViewClick = (row) => {
    navigate(`/doctor/view/${row.ids}`);
  };

  const handleEditClick = (row) => {
    navigate(`/doctor/edit/${row.ids}`);
  };

  const handleDeleteClick = (row) => {
    setdeleteId(row.ids);
    setopenDeleteModel(true);
  };

  const handleDeleteConfirm = () => {
    dispatch(deleteDoctor(deleteId));
    setopenDeleteModel(false);
  };
  
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <TextField
          fullWidth
          placeholder="Search doctors by name, email, phone or status..."
          value={searchTerm}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          variant="outlined"
          size="small"
        />
      </Box>
      
      <ReusableTable
        title="Doctors"
        columns={columns}
        data={filteredData}
        isLoading={loading}
        headerColor="#000"
        rowColor="#ffffff"
        alternateRowColor="#f5f5f5"
        onViewClick={handleViewClick}
        onEditClick={handleEditClick}
        onDeleteClick={handleDeleteClick}
        withPagination={true}
        withActions={true}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        showDownloadOption={true}
      />
      
      <Modal
        open={openDeleteModel}
        style={{ left: "35%", top: "35%" }}
        onClose={() => {
          setopenDeleteModel(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ width: "500px", background: " #fff", padding: "20px" }}>
          <Typography
            id="modal-modal-title"
            variant="h5"
            sx={{ fontSize: "large", fontWeight: "500" }}
            component="h2"
          >
            Delete Doctor
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Are you sure you want to delete this doctor?
          </Typography>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}
          >
            <Button variant="contained" onClick={handleDeleteConfirm}>
              OK
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setopenDeleteModel(false);
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default ListDoctor;